export default __webpack_public_path__ + "static/media/example_3@2x.d403543c.png";